import { Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import type { ComponentProps } from 'react';
import { useRef, useCallback } from 'react';

import { VitrinsCreditCardsFiltersForm } from 'features/VitrinsCreditCardsFiltersForm';
import { VitrinsOffersCards } from 'features/VitrinsOffers';

type Props = {
  isGrayBackground?: boolean;
  submitButtonText?: string;
  onOfferSubmit?: ComponentProps<typeof VitrinsOffersCards>['onOfferSubmit'];
  onFilterSubmit?: ComponentProps<typeof VitrinsCreditCardsFiltersForm>['onButtonClick'];
};

export const VitrinsCreditCardsOffers: FC<Props> = (props) => {
  const { isGrayBackground, submitButtonText, onOfferSubmit, onFilterSubmit } = props;
  const isMobile = useIsMobile();
  const offersCardsRef = useRef<HTMLDivElement | null>(null);

  const onButtonClick = useCallback(
    (amount: string) => {
      onFilterSubmit?.(amount);
      requestAnimationFrame(() => {
        offersCardsRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      });
    },
    [onFilterSubmit],
  );

  return (
    <Space
      direction="vertical"
      size={isMobile ? 24 : 32}
    >
      <VitrinsCreditCardsFiltersForm onButtonClick={onButtonClick} />
      <VitrinsOffersCards
        isGrayCards={isGrayBackground}
        submitButtonText={submitButtonText}
        onOfferSubmit={onOfferSubmit}
        summaryItemsCount={3}
        ref={offersCardsRef}
      />
    </Space>
  );
};
